<template>
  <div class="edit-main-offer">
    <action-dispatcher
      @success="setMainOffer"
      action="product/getProduct"
      :parameters="$route.params.id"
    >
      <div class="d-flex flex-column gap-4">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="text-semibold">Editar oferta principal</h5>
          <div class="d-flex gap-3">
            <snow-button
              size="sm"
              variant="gray"
              @click="
                $router.push({
                  name: 'product-prices',
                  params: { id: $route.params.id }
                })
              "
              text="Cancelar"
            />
            <snow-button
              size="sm"
              :disabled="!isValid"
              :loading="loading"
              text="Salvar"
              @click="submit"
            >
            </snow-button>
          </div>
        </div>
        <snow-input
          id="name"
          disabled
          v-model="form.name"
          label="Nome da oferta"
          info="Este nome será exibido apenas para você, em sua tabela de preços."
        />
        <snow-input
          rows="5"
          textarea
          id="description"
          disabled
          v-model="form.description"
          label="Descrição no checkout"
          :limit="980"
        />

        <h5 class="text-semibold mt-4">Precificação</h5>

        <snow-input
          v-model="form.price"
          money
          required
          label="Valor em Real Brasileiro (R$)"
          info="Defina quanto custará o seu produto. Certifique-se de que o valor não seja menor que R$ 4,00."
          :min="4"
          :errors="errors.price"
          :moneyConfig="moneyConfig"
        />
        <snow-input
          v-if="!isParcelledBillet"
          :disabled="!showForeign"
          :info="getInfo('USD')"
          v-model="form.price_usd"
          money
          label="Valor em Dólar Americano (US$)"
          :min="4"
          :errors="errors.price_usd"
          :moneyConfig="{ ...moneyConfig, currency: '$' }"
        />
        <snow-input
          v-if="!isParcelledBillet"
          :disabled="!showForeign"
          :info="getInfo('EUR')"
          v-model="form.price_eur"
          money
          label="Valor em Euro (€)"
          :min="4"
          :errors="errors.price_eur"
          :moneyConfig="{ ...moneyConfig, currency: '€' }"
        />

        <action-dispatcher
          v-if="form.price && form.price >= 4"
          action="sale/getInstallments"
          :key="`${form.price}`"
          :parameters="{
            product_id: $route.params.id,
            value: form.price,
            installments: 18
          }"
        >
          <snow-select
            select
            id="installment"
            label="Parcelamento"
            v-model="form.installments"
            :options="installmentOptions"
            :errors="errors.installments"
          />
        </action-dispatcher>
      </div>
    </action-dispatcher>
  </div>
</template>
<script>
import { formatMoney, formFields } from "@/functions/helpers";
import { defaultOffer } from "@/functions/product";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      ...formFields(
        [
          "id",
          "name",
          "description",
          "price",
          "price_usd",
          "price_eur",
          "currency",
          "installments",
          "status"
        ],
        {
          status: "active",
          currency: "BRL"
        }
      ),
      moneyConfig: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "",
        masked: false
      },
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("offer", ["offer", "orderBumpOffers"]),
    ...mapState("sale", ["installments"]),
    installmentOptions() {
      const opts = [];
      for (let id in this.installments) {
        opts.push({
          id: parseInt(id),
          name: `Até ${id} parcela${id - 1 ? "s" : ""} de R$ ${formatMoney(
            this.installments[id]
          )}`
        });
      }
      return opts;
    },
    isValid() {
      return (
        this.form.name &&
        this.form.description &&
        this.form.currency &&
        this.form.price &&
        this.form.price >= 4 &&
        (!this.hasUSD || this.form.price_usd >= 4) &&
        (!this.hasEUR || this.form.price_eur >= 4)
      );
    },
    showForeign() {
      return this.product.payment_methods?.some(({ id }) => id === 1);
    },
    hasUSD() {
      return !!this.form.price_usd && this.form.price_usd > 0;
    },
    hasEUR() {
      return !!this.form.price_eur && this.form.price_eur > 0;
    },
    isParcelledBillet() {
      return this.product?.billet_installments > 1;
    }
  },

  methods: {
    getInfo(currency) {
      if (this.showForeign) return "";
      const currencyName = {
        USD: "dólar americano",
        EUR: "euro"
      };
      return `Para habilitar configuração de preço em ${currencyName[currency]} seu checkout precisa aceitar Cartão de Crédito. Atualize a configuração de "Opções de Pagamento" do seu produto em "Configurar Checkout"`;
    },
    setMainOffer(product) {
      this.form = { 
        ...this.form, 
        ...defaultOffer(product)
      };
    },
    submit() {
      this.loading = true;
      const { price, price_eur, price_usd, installments } = this.form;
      this.$store
        .dispatch("product/put", {
          price,
          price_usd: parseFloat(price_usd) || null,
          price_eur: parseFloat(price_eur) || null,
          installments,
          id: this.$route.params.id
        })
        .then(() => {
          this.$message.success("Oferta principal salva com sucesso!");
          this.$router.push({
            name: "product-prices",
            params: { id: this.$route.params.id }
          });
        })
        .catch(error => {
          let msg = get_error_msg(
            error?.response?.data,
            TRANSLATE_FIELD_PRICE_MAP,
            "Erro ao salvar oferta"
          );
          this.$message.error(msg);
        })
        .finally(() => (this.loading = false));
      return;
    }
  }
};
</script>
<style lang="scss" scoped>
.edit-main-offer {
  background: var(--bg-2);
  padding: 24px;
  border-radius: 16px;
}
</style>
